import {Alert, IconWarningCircleHollow} from "@darwinex/components-library";
import React, {useEffect, useState} from "react";
import styles from "src/components/auth/Auth.module.scss"
import IconCheckCircle from "src/components/icons/IconCheckCircle";
import {useTranslationService} from "src/services/TranslationService";
import {getCoupon} from "../../api/commons";

export const SignUpInfo = ({showZeroAlert}) => {
    const {t} = useTranslationService();

    const [coupon, setCoupon] = useState('REFZEROMON');

    useEffect(() => {
        /*
        getCoupon('CLASSIC_REFERRAL').then((response) => {
            setCoupon(response.code);
        });
         */
    }, [])

    return <div className={styles.info_section}>
        <h3 className={styles.title}>{t('new-login.login-info.title')}</h3>
        <h4 className={styles.subtitle}>
            {t('new-login.login-info.traders')}
        </h4>
        <p className={styles.item}>
            <IconCheckCircle className={"dx-mr-5 flex-shrink-0"}/>
            {t('new-login.login-info.traders.1')}
        </p>
        <p className={styles.item}>
            <IconCheckCircle className={"dx-mr-5 flex-shrink-0"}/>
            {t('new-login.login-info.traders.2')}
        </p>
        <p className={styles.item}>
            <IconCheckCircle className={"dx-mr-5 flex-shrink-0"}/>
            {t('new-login.login-info.traders.3')}
        </p>
        {showZeroAlert && <div className={styles.item}>
            <Alert variant={"danger"} icon={<IconWarningCircleHollow width={24} height={24}/>}>
                {t('new-login.login-info.zero-recommendation', { coupon })}
            </Alert>
        </div>}
        <h4 className={styles.subtitle}>
            {t('new-login.login-info.investors')}
        </h4>
        <p className={styles.item}>
            <IconCheckCircle className={"dx-mr-5 flex-shrink-0"}/>
            {t('new-login.login-info.investors.1')}
        </p>
        <p className={styles.item}>
            <IconCheckCircle className={"dx-mr-5 flex-shrink-0"}/>
            {t('new-login.login-info.investors.2')}
        </p>
        <p className={styles.item}>
            <IconCheckCircle className={"dx-mr-5 flex-shrink-0"}/>
            {t('new-login.login-info.investors.3')}
        </p>
    </div>
}
